export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-android-e17b0b1252edc1a3fa7c708e6e37c59d.svg";